import DepartmentsAPI from '../../api/departments';

const state = {
  records: [],
  // GK-HUB: Department-scoped agents for ISP report filters
  departmentAgents: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isFetchingAgents: false,
  },
};

const getters = {
  getDepartments: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getDepartmentById: $state => id =>
    $state.records.find(d => d.id === Number(id)),
  // GK-HUB: Getter for department-scoped agents
  getDepartmentAgents: $state => $state.departmentAgents,
};

const actions = {
  async get({ commit }) {
    commit('setUIFlag', { isFetching: true });
    try {
      const { data } = await DepartmentsAPI.get();
      // GK-HUB: Unwrap { data: [...] } response envelope from departments controller
      const departments = data.data || data;
      commit('setDepartments', Array.isArray(departments) ? departments : []);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },

  async create({ commit }, departmentData) {
    commit('setUIFlag', { isCreating: true });
    try {
      const { data } = await DepartmentsAPI.create(departmentData);
      // GK-HUB: Unwrap { data: {...} } response envelope
      const dept = data.data || data;
      commit('addDepartment', dept);
      return dept;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('setUIFlag', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...updateData }) {
    commit('setUIFlag', { isUpdating: true });
    try {
      const { data } = await DepartmentsAPI.update(id, updateData);
      // GK-HUB: Unwrap { data: {...} } response envelope
      const dept = data.data || data;
      commit('updateDepartment', dept);
      return dept;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('setUIFlag', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    try {
      await DepartmentsAPI.delete(id);
      commit('removeDepartment', id);
    } catch (error) {
      throw new Error(error);
    }
  },

  // GK-HUB: Fetch agents for a specific department
  async fetchDepartmentAgents({ commit }, departmentId) {
    commit('setUIFlag', { isFetchingAgents: true });
    try {
      const { data } = await DepartmentsAPI.getAgents(departmentId);
      commit('setDepartmentAgents', data);
    } catch (error) {
      commit('setDepartmentAgents', []);
      throw new Error(error);
    } finally {
      commit('setUIFlag', { isFetchingAgents: false });
    }
  },

  // GK-HUB: Clear department agents (when no dept selected)
  clearDepartmentAgents({ commit }) {
    commit('setDepartmentAgents', []);
  },
  // GK-HUB: end department agents actions
};

const mutations = {
  setUIFlag($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  setDepartments($state, departments) {
    $state.records = departments;
  },
  addDepartment($state, department) {
    $state.records.push(department);
  },
  updateDepartment($state, department) {
    const index = $state.records.findIndex(d => d.id === department.id);
    if (index !== -1) {
      $state.records.splice(index, 1, department);
    }
  },
  removeDepartment($state, id) {
    $state.records = $state.records.filter(d => d.id !== id);
  },
  // GK-HUB: Mutation for department agents
  setDepartmentAgents($state, agents) {
    $state.departmentAgents = agents;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
